import {
  validateLength,
  validateNumber,
} from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const HomeawayLinkValidation = {
  headline: customMessageValidator(
    'homeaway_link_headline',
    validateLength({
      min: 20,
      max: 80,
      allowNone: false,
    }),
  ),

  description: customMessageValidator(
    'homeaway_link_description',
    validateLength({
      min: 400,
      max: 10000,
      allowNone: false,
    }),
  ),

  minimumAge: validateNumber({ gt: 0, integer: true, allowBlank: true }),
};
